export default __webpack_public_path__ + "static/media/geopoll_icon.caa74d9a.png";